<template>
  <div class="pub-option">
    <div class="card grow" @click="cardClicked">
      <div class="pub-option-title">{{ service.title }}</div>
      <div class="pub-option-description" v-html="description"></div>

      <div class="pub-option-pricing-container">
        <div class="pub-option-pricing">
          <div class="pub-option-price">
            <div class="pub-option-price-label snaps-label">Snaps Bonus</div>
            <div class="pub-option-price-number">
              <div class="points-container">
                <div class="points-icon">
                  <img src="/images/icons/snap.svg" class="points-icon-img" />
                </div>

                <div class="points">
                  {{ service.max_snap_cost | bigNumber }}
                </div>
              </div>
            </div>
          </div>

          <div class="pub-option-price">
            <div class="pub-option-price-label member-label">Member Price</div>
            <div class="pub-option-price-number">
              ${{ Math.round(service.price) }}
            </div>
          </div>

          <div class="pub-option-price">
            <div class="pub-option-price-label">Agency Price</div>
            <div class="pub-option-price-number number-agency">
              ${{ service.max_price }}
            </div>
          </div>

          <div class="clearfix"></div>
        </div>
      </div>

      <!-- <div class="details">
      <div class="price">${{ service.price }}</div>
      <div class="snap-bonus">
        <points :count="service.snap_bonus"></points>bonus
      </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import Points from "@/components/Points/Tag";

export default {
  name: "ServiceOption",
  props: ["service"],
  components: { Points },
  data: function () {
    return {
      descriptions: {},
      description: null,
    };
  },
  async created() {
    this.descriptions = {
      "product-description":
        "Have us research your book and audience and write a customized product description that persuades readers to purchase your book with detailed marketing copy.",
      "adword-keywords":
        "Receive a tailored list of 200 keywords and bid prices that you can upload directly into AMS to start a strong Amazon Ad Campaign for your book.",
      "ad-copy":
        "Attract potential buyers with compelling ad copy that targets readers who are the most likely to purchase your book.<br />(3 ad copy options)",
      "kdp-keywords":
        "Receive the best keywords and categories for getting your particular book ranked in its genre, as well as landing in top positions in buyers' search results. (7 keywords, 2 categories)",
    };

    this.description = this.descriptions[this.service.name];
  },
  methods: {
    cardClicked() {
      this.$router.push("/publish/add/" + this.service.name);
    },
  },
};
</script>

<style scoped lang="scss">
.pub-option {
  float: left;
  width: 50%;
}

.card {
  min-height: 210px;
  background: #fff;
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  margin: 12px 16px;
  padding: 0px 0;
  padding-bottom: 0 !important;
  border-radius: 8px;
  font-family: "Source Sans Pro";
}

.grow {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.grow:hover {
  transform: scale(1.03);
}

.pub-option-title {
  padding: 30px 0 0 0;
  font-size: 19pt;
  color: darken($color-blue, 0%);
  font-weight: 700;
  text-align: center;
  //padding-left: 60px;
}
.pub-option-description {
  height: 112px;
  font-size: 12pt;
  padding: 12px 40px 50px 40px;
}
.pub-option-unavailable {
  font-size: 12pt;
  padding: 0;
  text-align: center;
  font-weight: 700;
}

.pub-option-pricing-container {
  margin-top: 8px;
  border-top: 1px solid #eee;
  padding-top: 12px;
}

.pub-option-pricing {
  padding: 0px;
  padding-bottom: 16px;
  // padding-left: 50px;
  // width: 350px;
  // margin: 0 auto;
}

.pub-option-price {
  float: right;
  width: 150px;
}
.pub-option-price-label {
  font-size: 10.5pt;
  text-transform: uppercase;
  color: #666;
}
.pub-option-price-number {
  font-size: 13.5pt;
  font-weight: 600;
  text-transform: uppercase;
  color: #111;
}

.number-agency {
  text-decoration: line-through;
  color: #666 !important;
}

.member-label {
  color: darken(#e08d00, 4%);
}
.snaps-label {
  color: darken(#e08d00, 4%);
}

// Points Tag
.points-container {
  display: flex;
  justify-content: left;
  border-radius: 28px;
  padding: 3px 0 0 0;
  margin-left: -2px;
  margin-top: -1px;
}
.border {
  border: 2px solid darken($color-sidebar, 4%) !important;
}
.points-icon {
  flex-grow: 0;
  padding-top: 0px;
  margin-top: -1px;
}
.points-icon-img {
  width: 22px;
  color: $color-snaps;
  font-size: 18pt !important;
}
.points {
  flex-grow: 0;
  color: darken($color-snaps, 0%);
  margin-left: 5px;
  font-size: 13pt !important;
  font-weight: 600;
  font-family: "Source Sans Pro";
}
</style>